import { ButtonDownloadComponent, ButtonDownloadReviewModifyComponent, InfoRadicationDocComponent } from "@app/shared";
import { EventEmitter } from '@angular/core';
import { environment } from "@env/environment";

export class SpecialRadicationConfig {
  // se emite cada vez que se realiza una accion con los botones de la tabla
  accion: EventEmitter<any> = new EventEmitter();
  // se emite cada vez que se realiza una accion con los botones de la tabla de stickers
  accionSticker: EventEmitter<any> = new EventEmitter();
  // se emite cada vez que se realiza una accion con los botones de la tabla de historial de modificaciones
  accionModify: EventEmitter<any> = new EventEmitter();
  // Configuraciones de la tabla
  settings = {};
  // Configuraciones de la tabla de stickers
  settingsStickers = {};
  // configuración de la tabla de historial de modificaciones de documentos
  settingsHistoryModify = {};



  constructor() {
    const self = this;
    if(environment.hiddenExpTypeDocument){
      this.settings = {
        mode: 'external',
        noDataMessage: 'La tarea actual no contiene datos',
        actions: false,
        attr: {
          class: 'table-bordered table-hover'
        },
        columns: {
          tipo_documental: {
            editable: false,
            addable: false,
            class: 'prueba',
            title: 'Tipo documental',
            filter: {
              inputClass: 'form-control',
            },
            type: 'custom',
            renderComponent: InfoRadicationDocComponent,
            onComponentInitFunction(instance: any) {
              instance.type = "tipo_documental";
            }
          },
          subserie: {
            editable: false,
            addable: false,
            title: 'Subserie',
            filter: {
              inputClass: 'form-control',
            },
            class: 'prueba',
            type: 'custom',
            renderComponent: InfoRadicationDocComponent,
            onComponentInitFunction(instance: any) {
              instance.type = "subserie";
            }
          },
          serie: {
            title: 'Serie',
            class: 'prueba',
            filter: {
              inputClass: 'form-control',
            },
            type: 'custom',
            renderComponent: InfoRadicationDocComponent,
            onComponentInitFunction(instance: any) {
              instance.type = "serie";
            }
          },
        },
      };
    }else{
      this.settings = {
        mode: 'external',
        noDataMessage: 'La tarea actual no contiene datos',
        actions: false,
        attr: {
          class: 'table-bordered table-hover'
        },
        columns: {
          tipo_documental: {
            editable: false,
            addable: false,
            class: 'prueba',
            title: 'Tipo documental',
            filter: {
              inputClass: 'form-control',
            },
            type: 'custom',
            renderComponent: InfoRadicationDocComponent,
          },
          subserie: {
            title: 'Subserie',
            filter: false,
            class: 'prueba',
          },
          serie: {
            title: 'Serie',
            class: 'prueba',
            filter: false,
          },
          // action: {
          //   title: 'Acción',
          //   filter: false,
          //   type: 'custom',
          //   renderComponent: ButtonDownloadComponent,
          //   onComponentInitFunction(instance: any) {
          //     instance.save.subscribe((data: any) => {
          //       // controla el evento click del boton
          //       self.accion.emit(data);
          //     });
          //   }
          // },
        },
      };
    }
    
    this.settingsStickers = {
      mode: 'external',
      noDataMessage: 'No hay rótulos disponibles',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        nombre: {
          editable: false,
          addable: false,
          class: 'prueba',
          title: 'Nombre',
          filter: {
            inputClass: 'form-control',
          },
        },
        action: {
          title: 'Acción',
          filter: false,
          type: 'custom',
          renderComponent: ButtonDownloadComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accionSticker.emit(data);
            });
          }
        },
      },
    };

    this.settingsHistoryModify = {
      mode: 'external',
      noDataMessage: 'La el documento no contiene modificaciones',
      actions: false,
      attr: {
        class: 'table-bordered table-hover'
      },
      columns: {
        fecha: {
          editable: false,
          addable: false,
          title: 'Fecha',
          filter: {
            inputClass: 'form-control',
          },
        },
        motivo: {
          editable: false,
          addable: false,
          title: 'Motivo',
          filter: {
            inputClass: 'form-control',
          },
        },
        responsable: {
          editable: false,
          addable: false,
          title: 'Responsable',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.responsable) {
              return row.responsable.nombres + ' ' + row.responsable.apellidos;
            }else{
              return '';
            }
          },
        },
        fecha_aprobacion: {
          editable: false,
          addable: false,
          title: 'Fecha de aprobación',
          filter: {
            inputClass: 'form-control',
          },
        },
        responsable_aprobacion: {
          editable: false,
          addable: false,
          title: 'Responsable de Aprobación',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.responsable_aprobacion) {
              return row.responsable_aprobacion.nombres + ' ' + row.responsable_aprobacion.apellidos;
            }else{
              return '';
            }
          },
        },
        motivo_rechazo: {
          editable: false,
          addable: false,
          title: 'Motivo de rechazo',
          filter: {
            inputClass: 'form-control',
          },
        },
        aprobacion: {
          editable: false,
          addable: false,
          title: 'Aprobado',
          filter: {
            inputClass: 'form-control',
          },
          valuePrepareFunction: (cell: any, row: any) => {
            if (row.fecha_aprobacion) {
              return row.aprobacion ? 'Si' : 'No';
            }else{
              return '';
            }
          },
        },
        id: {
          title: 'Documento',
          filter: false,
          type: 'custom',
          renderComponent: ButtonDownloadReviewModifyComponent,
          onComponentInitFunction(instance: any) {
            instance.save.subscribe((data: any) => {
              // controla el evento click del boton
              self.accionModify.emit(data);
            });
          }
        },
      },
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/special-radication/shared/special-radication-config.service.ts